import React from 'react';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import ServicesGrid from '../components/home/ServicesGrid';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      <ServicesGrid />
    </div>
  );
};

export default Home;